window.getCookie = function(name){
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];

  return null;
}

window.setCookie = function(name,value,expireInMs) {
    var expires = "";
    var cookie = name + "=" + encodeURIComponent(value);
    if(typeof expireInMs === "number") {
      var date = new Date();
     	date.setTime(date.getTime() + expireInMs);
      cookie+= "; expires=" + date.toUTCString();
    }
    cookie+="; path=/";
    document.cookie = cookie;
}

window.getParameter = function(name){
	let url = new URL(window.location.toLocaleString());
	let params = url.searchParams;
	return params.get(name);
}

window.getBasename = function(path){
	return path.substring(path.lastIndexOf('/')+1);
}

document.addEventListener('DOMContentLoaded', function() {
	  // new WOW().init();

	  var $window = $(window);
	  var $header = $('#header');
	  var $body = $('body');
	  var $openElmt = $('#open-menu');
	  var $btnHautPage = $('#fleche-haut-page');

	  function stickIt() {
	  	if ($(window).scrollTop() > 0) {
	  		$header.addClass('fixed');
	  		$btnHautPage.addClass('show-me');
	  	}
	  	else {
	  		$header.removeClass('fixed');
	  		$btnHautPage.removeClass('show-me');
	  	}
	  }

	// Carrtousel avec Multiples images.
	//var flexslider = $('.flexslider').

	function getGridSize() {
		return (window.innerWidth < 600) ? 2 :
		(window.innerWidth < 900) ? 3 : 4;
	}

	function handlerResize() {
		var fs = flexslider.data('flexslider');
		if(!fs) return;
		var gridSize = getGridSize();
		fs.vars.minItems = gridSize;
		fs.vars.maxItems = gridSize;
		fs.doMath();
	}

	// Smooth scroll anchor
	var hash = window.location.hash.substr(1);
	if (hash != "") {
		var element = $('#' + hash);
		if (element.length) {
			$('html, body').animate({
				scrollTop: $(element).offset().top - 200
			}, 800);
		}
	}

	// Boutton de retour.
	function retourBouton () {
		$btnHautPage.on("click",function() {
			$('html, body').animate({ scrollTop: 0 }, 'slow');
		});
	}
	retourBouton();

	// Le brin de laurier.
	$('.range-text-media').first().css( "margin-bottom", "1rem" ).find('.rameau').css( "display", "inline" );

	// Flexslider diapo.
	var flexslider = $('.flexslider').flexslider({
		animation: "slide",
		animationLoop: false,
		controlNav: false,
		itemWidth: 210,
		itemMargin: 5,
		move: 1,
		slideshowSpeed: 7000,           //Integer: Set the speed of the slideshow cycling, in milliseconds
		animationSpeed: 1000,
		minItems: getGridSize(),
		maxItems: getGridSize()
	});

	// Handlers.
	// Comportement sticky Menu.
	$window.scroll(stickIt);
	$window.resize(handlerResize);

	// Nav bar.
	$openElmt.click(openClickHandler);

	function openClickHandler() {
		$body.toggleClass('menu-is-open');
		$openElmt.toggleClass('is-active');
	}

	// Validation Client side and Captcha call.
	function validate(event) {
		console.log('after validate, call captcha');
		grecaptcha.execute();
	}

	function onloadFormFooter() {
		var element = document.getElementById('zY21zX2ZpZWxkXzY');
		element.onclick = validate;
	}


	// Parallax.
	$('.my-paroller').paroller();

	// Footer parallax image
	// Need test if row "Carte Google Map - Localisation Programme ou Terrain" is set because
	// that insert filter button programmatically after DOM load and add delage after parallax is initilized
	// so if row map insert, it call itsel parallax initialization, in no insert, call parallax init here :
	if(!$('.range-carte-interactive').length) {
		$('[data-parallax="scroll-custom"]').parallax({imageSrc: '/utils/public/img/footer4.jpg'});
		console.log('Parallax init by initilize');
	}

	// Validation : definition des messages.
	jQuery.extend(jQuery.validator.messages, {
		required: "Ce champ est requis.",
		email: "Veuillez saisir une adresse e-mail valide.",
	});


	// Gestion des tableaux dépliants listings.
	$('#programme-logements-list').on('shown.bs.collapse', function (e) {
		var $target = $( e.target );

		if($target) {
			$('html, body').animate({
				scrollTop: $target.parent().offset().top - $('#header').height()
			}, 500);
		}
	});

	// Popover
	$('[data-toggle="popover"]').popover({
		container: 'body',
	});

	// Fancybox pour les images de la page.
	$('[data-fancybox*="data-fancybox-gallery"]').fancybox({
		baseClass: 'fancy-form-layout',
		toolbar: 'auto',
		buttons: [
		"close"
		],
	})

	// Fancybox pour les images de la page.
	$('[data-fancybox*="data-fancybox-page"]').fancybox({
		//toolbar  : false,
		baseClass: 'fancy-form-layout',
		toolbar: 'auto',
		buttons: [
		"close"
		],
	})

	// Fancybox pour appel ajax formulaire.
	$('[data-fancybox*="data-fancybox-form"]').fancybox({
		toolbar  : false,
		smallBtn : true,
		baseClass: 'fancy-form-layout',
		iframe : {
			//preload : false
		}
	})

	// Initialize WOW for animations.
	new WOW().init();

	// Detect if media blocks have content
	if ($('body').find('.atm-dummy-row-tag').length < 1) {
		if ($('.range-mise-en-avant-trois-media').length > 0) {
			$('.range-mise-en-avant-trois-media .block-img').each(function() {
				if ($(this).find('.img-ajust-wrapper').length < 1) {
					$(this).remove();
				}
			})
		}
	}

	//require btn-brochure behavior initialization
	require('brochure.js');
});

